/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type CollegamentoRichiestaDTOTipo =
  (typeof CollegamentoRichiestaDTOTipo)[keyof typeof CollegamentoRichiestaDTOTipo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollegamentoRichiestaDTOTipo = {
  OSSERVAZIONE: 'OSSERVAZIONE',
} as const;
